{
  "eyebrow": "Creează contul",
  "title": "Câteva detalii despre compania ta.",
  "sub": "Vei fi administratorul principal. Poți invita alți administratori după configurare.",
  "company": "Companie",
  "companyName": "Numele companiei",
  "companyVat": "Cod TVA",
  "companyVatBssHint": "Necesar pentru declarațiile la asigurările sociale belgiene (DIMONA).",
  "companyCountry": "Țară",
  "admin": "Administrator principal",
  "adminFirst": "Prenume",
  "adminLast": "Nume",
  "adminEmail": "Email de serviciu",
  "adminPhone": "Telefon",
  "adminPw": "Parolă",
  "adminPwHint": "Cel puțin 10 caractere, o cifră.",
  "adminPwShow": "Arată parola",
  "adminPwHide": "Ascunde parola",
  "terms": {
    "pre": "Sunt de acord cu",
    "t": "Termenii și condițiile",
    "and": "și",
    "p": "Politica de confidențialitate"
  },
  "cta": "Creează contul și continuă",
  "errors": {
    "required": "Obligatoriu",
    "tooShort": "Prea scurt",
    "invalidEmail": "Introdu un email valid",
    "invalidVat": "Introdu un cod TVA valid",
    "invalidBelgianVat": "Introdu un cod TVA belgian valid (de ex. BE0123456789).",
    "invalidPhone": "Introdu un telefon valid",
    "passwordWeak": "Cel puțin 10 caractere cu o cifră",
    "termsRequired": "Trebuie să accepți termenii",
    "emailExists": "Acest email este deja folosit",
    "vatRequiredForBss": "Codul TVA este obligatoriu pentru asigurările sociale belgiene",
    "network": "Eroare de rețea sau de server. Reîncearcă."
  },
  "verify": {
    "awaitingTitle": "Verifică-ți emailul",
    "awaitingSub": "Am trimis un link de verificare la {{email}}. Dați clic pe el pentru a vă activa contul și a începe perioada de probă gratuită.",
    "awaitingSubNoEmail": "V-am trimis un link de verificare. Dați clic pe el pentru a vă activa contul și a începe perioada de probă gratuită.",
    "resend": "Retrimite emailul",
    "resendCooldown": "Retrimite în {{seconds}}s",
    "verifyingTitle": "Se verifică…",
    "successTitle": "Perioada ta de probă gratuită de 30 de zile a început!",
    "successSub": "Fără card de credit. Conectați-vă la tabloul de bord pentru a începe să folosiți Done-it.",
    "errorTitle": "Nu am putut verifica linkul",
    "errorSub": "Este posibil ca linkul să fi expirat. Începe din nou de la detaliile contului.",
    "errorCta": "Înapoi la cont",
    "interstitial": "Verificare email",
    "subscribedTitle": "Contul tău este gata",
    "subscribedSub": "Plata a fost deja efectuată. Conectează-te la panou pentru a începe să folosești Done-it.",
    "subscribedCta": "Conectează-te la panou",
    "successCta": "Deschideți tabloul de bord",
    "successNote": "Veți primi câteva e-mailuri utile în timpul perioadei de probă și, spre final, un link pentru abonare.",
    "awaitingSubFree": "Am trimis un link de verificare la {{email}}. Dați clic pe el pentru a vă activa contul gratuit — Time Zero este gratuit pentru totdeauna, fără card de credit.",
    "awaitingSubFreeNoEmail": "V-am trimis un link de verificare. Dați clic pe el pentru a vă activa contul gratuit — Time Zero este gratuit pentru totdeauna, fără card de credit.",
    "successTitleFree": "Contul tău gratuit este gata!",
    "successNoteFree": "Time Zero este gratuit pentru totdeauna în limitele sale. Faceți upgrade oricând pentru utilizare nelimitată."
  }
}
